import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { MatterStatus } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterStatusContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  onDelete: () => void;
  onEdit: () => void;
  status: MatterStatus;
  trigger: ReactNode;
};

export function MatterStatusContextMenu({
  canDelete,
  canEdit,
  onDelete,
  onEdit,
  status,
  trigger,
}: MatterStatusContextMenuProps) {
  return (
    <ContextMenu
      entityName="matter status"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(status.label, "Status label");
            }}
          >
            <Clipboard />
            Copy status label
          </ContextMenuItem>
          <ContextMenuItem
            disabled={!status.description}
            onSelect={() => {
              void copyToClipboard(status.description ?? "", "Description");
            }}
          >
            <Clipboard />
            Copy description
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
